import flatpickr from "flatpickr";
require("flatpickr/dist/flatpickr.min.css");

export default (element, defaultDate, livewireProperty) => ({
  init() {
    flatpickr(element, {
      enableTime: true,
      altInput: true,
      time_24hr: false,
      defaultDate: defaultDate,
      onValueUpdate: (selectedDates, dateStr, instance) => {
        if (this.$wire && livewireProperty) {
          this.$wire.set(livewireProperty, dateStr);
        }
      },
    });
  },
});
